// Central source of truth for activity types
export const ACTIVITY_TYPES = [
    "G2",
    "STP",
    "Video Interview",
    "IOI",
    "Other"
];
const ActivityTypeMapping = {
    G2: "G2",
    "Service Touchpoint": "STP",
    "Video Interview": "Video Interview",
    "Internal Interview": "IOI",
    Other: "Other"
};
export function getActivityTypeByLabel(label) {
    return ActivityTypeMapping[label];
}
